import { render } from "./ub-black.vue?vue&type=template&id=54f1eef8&scoped=true"
import script from "./ub-black.vue?vue&type=script&lang=js"
export * from "./ub-black.vue?vue&type=script&lang=js"

import "./ub-black.vue?vue&type=style&index=0&id=54f1eef8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54f1eef8"]])

export default __exports__